export const RETRY_DELAY_MS = 2000

// Runs fn, and if it fails, waits and runs it one more time. shouldRetry is
// checked after the failure and again after the wait, so callers can skip
// failures a second try can't fix; the failure that ends it is thrown as-is.
export default async function retryOnce(
  fn,
  { shouldRetry = () => true, delayMs = RETRY_DELAY_MS } = {}
) {
  try {
    return await fn()
  } catch (error) {
    if (!shouldRetry()) {
      throw error
    }
    await new Promise((resolve) => setTimeout(resolve, delayMs))
    if (!shouldRetry()) {
      throw error
    }
    return fn()
  }
}
